import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const ExternalForm = (props) => {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false)
  const iframeRef = useRef()

  useEffect(() => {
    return () => {
      props.removeSubmitListener !== undefined && props.removeSubmitListener(iframeRef)
    }
  })

  const setIframeHeight = () => {
    iframeRef.current.style.height = iframeRef.current.contentWindow.document.body.scrollHeight + "px"
  }

  const onLoadIframe = (e) => {
    // when iframe is loaded for the second time, the form has been submitted.
    if (isIframeLoaded) {
      setTimeout(() => {
        props.onDone()
      }, 2000)
    }
    else {
      setIframeHeight()
      props.addSubmitListener !== undefined && props.addSubmitListener(iframeRef)
      setIsIframeLoaded(true)
    }
  }

  const iframeUrl = "/live_board/v1/forms/" + props.config.metadata.form_id
  const formTitle = props.config.form.form_title || props.config.text

  return (
    <section className="external-form-container">
      { formTitle && <h1>{formTitle}</h1> }
      <iframe ref={iframeRef} src={iframeUrl} className="form-iframe" onLoad={onLoadIframe}></iframe>
    </section>
  )
}

ExternalForm.propTypes = {
  config: PropTypes.object.isRequired,
  addSubmitListener: PropTypes.func,
  removeSubmitListener: PropTypes.func,
  onDone: PropTypes.func
}

export default ExternalForm